import { render, staticRenderFns } from "./CoozzyEvorestIcon.vue?vue&type=template&id=29035e77&scoped=true"
import script from "./CoozzyEvorestIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyEvorestIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyEvorestIcon.vue?vue&type=style&index=0&id=29035e77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29035e77",
  null
  
)

export default component.exports